type AuthenticationError = {
  sessionExpired?: boolean;
  response?: { status?: number; headers?: unknown };
};

/** Only the explicit Bearer challenge means the server-side session has expired. */
export function isSessionExpiredError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const { sessionExpired, response } = error as AuthenticationError;
  if (sessionExpired === true) return true;
  if (response?.status !== 401 || !response.headers || typeof response.headers !== "object") return false;

  const headers = response.headers as Record<string, unknown> & { get?: (name: string) => unknown };
  const value =
    typeof headers.get === "function"
      ? headers.get("www-authenticate")
      : Object.entries(headers).find(([name]) => name.toLowerCase() === "www-authenticate")?.[1];
  const challenge = Array.isArray(value) ? value.join(", ") : value;
  if (typeof challenge !== "string") return false;

  let scheme = "";
  let parameters: Record<string, string> = {};
  const expired = () => scheme === "bearer" && parameters.error === "invalid_token" && parameters.error_description === "SessionExpired";

  // Split on commas outside quoted strings; parameters from different schemes must not mix.
  for (const [part] of challenge.matchAll(/(?:[^,"]|"(?:\\.|[^"\\])*")+/g)) {
    let parameter = part.trim();
    const prefix = /^([a-z][a-z\d_-]*)\s+([^=\s].*)$/i.exec(parameter);
    if (prefix?.[1] && prefix[2]) {
      if (expired()) return true;
      scheme = prefix[1].toLowerCase();
      parameters = {};
      parameter = prefix[2];
    }
    const match = /^([a-z_]+)\s*=\s*(?:"((?:\\.|[^"\\])*)"|([^\s,]+))$/i.exec(parameter);
    if (match?.[1]) parameters[match[1].toLowerCase()] = (match[2] ?? match[3] ?? "").replace(/\\(.)/g, "$1");
  }
  return expired();
}
